<template>
  <div class="search-form px-2">
    <div class="col-sm-12 search-form-title">
      <font-awesome-icon icon="search" />
      {{ $t('common.search') }}
    </div>
    <div class="editor-form">
      <div class="row">
        <div class="col-sm-6">
          <span class="search-title">{{ $t('delivery_note.date') }} - {{ $t('trip_list.road_sec_from') }}</span>
          <date-time-picker
            v-model:date="fromDate"
            class="routa-input"
            format="dd.MM.yyyy HH:mm"
            :enableTimePicker="true"
            :placeholder="$t('observations_videos.search_input_format')"
          />
        </div>
        <div class="col-sm-6">
          <span class="search-title">{{ $t('delivery_note.date') }} - {{ $t('trip_list.road_sec_to') }}</span>
          <date-time-picker
            v-model:date="toDate"
            class="routa-input"
            format="dd.MM.yyyy HH:mm"
            :enableTimePicker="true"
            :append-to-body="false"
            :placeholder="$t('observations_videos.search_input_format')"
          />
        </div>
      </div>
      <div class="row">
        <div class="col-sm-6 pl-3 pr-3">
          <span class="span-title">{{ $t('observation_reports.template') }}</span>
            <select
                id="template"
                class="form-select form-select-sm"
                v-model="template"
            >
                <option
                    v-for="option in templateOptions"
                    :key="option.value"
                    :value="option.value"
                >
                    {{ option.text }}
                </option>
            </select>
        </div>
        <div class="col-sm-6 ps-0 pe-1">
          <open-contract-filter
            ref="filter"
            :from="fromDate"
            :to="toDate"
            :contract="contract"
            :apply-padding="false"
            :row-view="false"
            :show-only-my-contracts-option="true"
            :show-title="true"
            :show-company="false"
            @contract-selected="setContract"
          />
        </div>
      </div>
      <div class="col-sm-12 button-container">
        <button
          class="btn btn-sm btn-info form-button"
          @click.stop="$emit('addTemplate')"
        >
          {{ $t('observation_reports.add') }}
        </button>
          <button
              class="btn btn-sm btn-danger form-button"
              @click.stop="onReset"
          >
              {{ $t('ins_report.clear') }}
          </button>
        <button
          class="btn btn-sm btn-primary form-button"
          :disabled="!template"
          @click.stop="onSubmit"
        >
          {{ $t('ins_report.search') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import {timeUtils} from '../../mixins/TimeUtils'
import OpenContractFilter from "@/components/contract/OpenContractFilter";
import DateTimePicker from "@/components/common/DateTimePicker";

export default {
    name: 'ReportSearch',
    components: {OpenContractFilter, DateTimePicker},
    mixins: [timeUtils],
    props: {
        user: {
            type: Object,
            default: null
        },
        templates: {
            type: Array,
            default() {
                return []
            }
        }
    },
    data: function () {
        return {
            fromDate: null,
            toDate: null,
            contract: null,
            template: null,
            templateOptions: [],
            company: null,
        }
    },
    watch: {
        templates: function () {
            this.initTemplateOptions()
        },
        template: function () {
            this.$emit('reportSelected', this.template)
        }
    },
    mounted() {
        this.initTemplateOptions()
        this.fromDate = this.getMonthStart()
        this.toDate = this.getToday()
    },
    methods: {
        initTemplateOptions() {
            if (this.templates) {
                this.templateOptions = []
                this.templates.forEach(item =>
                    this.templateOptions.push({text: item.name, value: item.id})
                )
            } else {
                this.templateOptions = []
            }
        },
        setContract: function (contract) {
            this.contract = contract
        },
        companySet: function (company) {
            this.company = company
        },
        onSubmit: function () {
            let params = {}
            if (this.contract) {
                params.contract = this.contract.id
            }
            params.from = this.fromDate
            params.to = this.toDate
            let template = this.templates.find(item => item.id === this.template)
            params.observationType = template.observation_type.id
            this.$emit('search', params)
        },
        onReset: function () {
            this.contract = null
            this.company = null
            this.$refs.filter.resetData()
        }
    }
}
</script>
